import { forwardRef } from 'react'
import Layout from '../event-preview/Layout'
import OrganizeBy from '../event-preview/OrganizeBy'
import TagsSection from '../event-preview/TagsSection'
import VenueLocationSection from '../event-preview/VenueLocationSection'
import ScheduleSection from '../event-preview/ScheduleSection'
import TermsAndFaqs from '../event-preview/TermsAndFaqs'
import Description from '../event-preview/Description'
import ShareEvent from '../event-preview/ShareEvent'

const MoreEventDetail = forwardRef(({ eventData }, ref) => {
    const isSingleDayEventWithSlots =
        eventData?.event_type === 'single_day' &&
        eventData?.schedules[0]?.slots &&
        eventData?.schedules[0]?.slots.length > 0;

    const isMultiDateEvent = eventData?.event_type === 'multi_day';

    return (
        <div className="event-more-detail-section" ref={ref}>
            <div className="event-details-flexbox-container">

                <div className="event-detail-left-flex-box">
                    <Description description={eventData?.description} />
                    <TermsAndFaqs
                        shmoozTerms={eventData?.shmoozTerms}
                        eventOrganizerTerms={eventData?.terms_and_conditions}
                        shmoozFaqs={eventData?.shmoozFaqs}
                        eventOrganizerFaqs={eventData?.faq}
                    />
                </div>

                <div className="event-detail-right-flex-box">

                    {(isSingleDayEventWithSlots || isMultiDateEvent) && (
                        <ScheduleSection previewData={eventData} />
                    )}

                    {(
                        (eventData?.subcategories && eventData?.subcategories.length > 0) ||
                        (eventData?.formats && eventData?.formats.length > 0) ||
                        (eventData?.tags && eventData?.tags.length > 0)
                    ) && (
                            <TagsSection
                                subcategories={eventData?.subcategories || []}
                                formats={eventData?.formats || []}
                                tags={eventData?.tags || []}
                            />
                        )
                    }

                    {!eventData?.online_event && (
                        <VenueLocationSection
                            venueName={eventData?.venue}
                            address={eventData?.address}
                            latitude={eventData?.latitude}
                            longitude={eventData?.longitude}
                        />
                    )}

                    {eventData?.event_layout && <Layout layoutUrl={eventData?.event_layout} />}

                    {eventData?.creator_name && <OrganizeBy organizerName={eventData?.creator_name} />}

                    <ShareEvent />
                </div>

            </div>
        </div>
    )
})

export default MoreEventDetail